const Teams = () => {
  return (
    <div role="tabpanel" aria-labelledby="teams-tab-panel">
      Hello in teams tab
    </div>
  );
};

export default Teams;
